export default "__VITE_ASSET__BXvHt_HK__"